/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Base Styles
import colors from "../../base/colors";
import typography from "../../base/typography";

// Material Dashboard 2 React Helper Functions
import pxToRem from "../../functions/pxToRem";

const { dark_teal, secondary, gold } = colors;
const { size } = typography;

const contained = {
  base: {
    backgroundColor: gold.main,
    minHeight: pxToRem(40),
    color: dark_teal.main,
    padding: `${pxToRem(10)} ${pxToRem(24)}`,

    "&:hover": {
      backgroundColor: gold.focus,
      color: dark_teal.main,
    },

    "&:active, &:active:focus, &:active:hover": {
      opacity: 0.85,
      color: dark_teal.main,
    },

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(16)} !important`,
    },
  },

  small: {
    minHeight: pxToRem(32),
    padding: `${pxToRem(6)} ${pxToRem(16)}`,
    fontSize: size.xs,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    minHeight: pxToRem(47),
    padding: `${pxToRem(12)} ${pxToRem(28)}`,
    fontSize: size.sm,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  primary: {
    backgroundColor: gold.main,
    color: dark_teal.main,

    "&:hover": {
      backgroundColor: gold.focus,
      color: dark_teal.main,
    },

    "&:focus:not(:hover)": {
      backgroundColor: gold.focus,
      color: dark_teal.main,
    },
  },

  secondary: {
    backgroundColor: secondary.main,
    color: dark_teal.main,

    "&:hover": {
      backgroundColor: secondary.focus,
      color: dark_teal.main,
    },

    "&:focus:not(:hover)": {
      backgroundColor: secondary.focus,
      color: dark_teal.main,
    },
  },
};

export default contained;
